import React from "react";
import formatDateAndTime from "../../common/formatDateAndTime";

const Bookingdetails1 = ({
  summaryDetails,
  vehicleDetails,
  paymentDetailsData,
  cities,
}) => {
  const filteredTransactions = paymentDetailsData?.fareBreakUp || [];
  const fleetBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues")
  )?.fleetBookingStatus;
  const fuelType = JSON.parse(localStorage.getItem("catalogValues"))?.fuelType;
  const transmissionType = JSON.parse(
    localStorage.getItem("catalogValues")
  )?.transmissionType;
  

  return (
    <div>
      <div className="bg-white shadow-lg rounded-lg p-6 max-w-6xl mx-auto my-6">
        <div className="bg-gray-50 shadow-lg rounded-xl p-6 border border-blue-100">
          <div className="flex flex-col md:flex-row gap-8">
            {/* Left Panel - Vehicle Details */}
            <div className="flex-1 flex flex-col items-center md:items-start text-center md:text-left">
              <img
                src={vehicleDetails?.imageUrl || "/placeholder-car.png"}
                alt="Car"
                className="w-28 h-28 object-cover rounded-lg shadow-md mb-4"
              />
              <div className="space-y-2 text-sm">
                <p>
                  <span className="font-semibold text-gray-600">
                    Registration Number:
                  </span>{" "}
                  <span className="text-gray-800">
                    {summaryDetails?.vehicleRegistrationNo || "N/A"}
                  </span>
                </p>
                <p>
                  <span className="font-semibold text-gray-600">
                    Vehicle Name:
                  </span>{" "}
                  <span className="text-gray-800">
                    {summaryDetails?.vehicleName || "N/A"}
                  </span>
                </p>
                <p>
                  <span className="font-semibold text-gray-600">
                    Fuel Type:
                  </span>{" "}
                  <span className="text-gray-800">
                    {fuelType[vehicleDetails?.fuelType] || "N/A"}
                  </span>
                </p>
                <p>
                  <span className="font-semibold text-gray-600">
                    Transmission:
                  </span>{" "}
                  <span className="text-gray-800">
                    {transmissionType[vehicleDetails?.transmissionType] ||
                      "N/A"}
                  </span>
                </p>
              </div>
            </div>

            {/* Right Panel - Booking Info */}
            <div className="flex-[2] grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4 text-sm">
              <p>
                <span className="font-semibold text-gray-600">Booking ID:</span>{" "}
                <span className="text-gray-800">
                  {summaryDetails?.id || "N/A"}
                </span>
              </p>
              <p>
                <span className="font-semibold text-gray-600">Start Date:</span>{" "}
                <span className="text-gray-800">
                  {formatDateAndTime(summaryDetails?.bookFrom) || "N/A"}
                </span>
              </p>
              <p>
                <span className="font-semibold text-gray-600">End Date:</span>{" "}
                <span className="text-gray-800">
                  {formatDateAndTime(summaryDetails?.bookTo) || "N/A"}
                </span>
              </p>
              <p>
                <span className="font-semibold text-gray-600">Status:</span>{" "}
                <span className="uppercase text-xs font-bold text-blue-600">
                  {fleetBookingStatus[summaryDetails?.bookingStatus] || "N/A"}
                </span>
              </p>
              <p>
                <span className="font-semibold text-gray-600">City:</span>{" "}
                <span className="text-gray-800">
                  {cities?.[String(summaryDetails?.cityId)] || "N/A"}
                </span>
              </p>

              <p>
                <span className="font-semibold text-gray-600">
                  Total Booking Hrs:
                </span>{" "}
                <span className="text-gray-800">
                  {summaryDetails?.bookingHrs || "N/A"} Hrs
                </span>
              </p>
              <p>
                <span className="font-semibold text-gray-600">
                  Overall Free Kms:
                </span>{" "}
                <span className="text-gray-800">
                  {summaryDetails?.overallFreeKm || "N/A"} Kms
                </span>
              </p>
              <p>
                <span className="font-semibold text-gray-600">
                  Customer Name:
                </span>{" "}
                <span className="text-gray-800">
                  {summaryDetails?.customerName || "N/A"}
                </span>
              </p>
              <p>
                <span className="font-semibold text-gray-600">
                  Phone Number:
                </span>{" "}
                <span className="text-gray-800">
                  {summaryDetails?.customerMobile || "N/A"}
                </span>
              </p>
            </div>
          </div>
        </div>

        <div className="section mt-10">
          <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-2 border-b-4 pb-2 border-blue-500">
            Billing Details (Package: {summaryDetails?.packageDetails} Km)
          </h2>

          {/* Table */}
          <div className="overflow-auto rounded-lg shadow bg-white">
            <table className="min-w-full text-sm text-left">
              <thead className="bg-gray-800 text-white">
                <tr>
                  <th className="p-4">Description</th>
                  <th className="p-4">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b hover:bg-gray-50">
                  <td className="p-4">
                    Security Deposit
                    <br />
                  </td>
                  <td className="p-4">1500</td>
                </tr>
                {filteredTransactions?.map((txn) => (
                  <>
                    {" "}
                    <tr key={txn?.id} className="border-b hover:bg-gray-50">
                      <td className="p-4">
                        {txn?.value}
                        <br />
                      </td>
                      <td className="p-4">{txn?.amount}</td>
                    </tr>
                  </>
                ))}
                {filteredTransactions?.length === 0 && (
                  <tr>
                    <td colSpan="7" className="text-center p-4 text-gray-500">
                      No transactions found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bookingdetails1;
